import { render, staticRenderFns } from "./TenantCustomerAddress.vue?vue&type=template&id=49095f26"
import script from "./TenantCustomerAddress.vue?vue&type=script&lang=js"
export * from "./TenantCustomerAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports